import { KycVerificationResponse } from '@percent/admin-dashboard/api/types'

export const mockKycVerificationResponse: { data: KycVerificationResponse } = {
  data: {
    id: 'kycv_2gZ5xMockKycVerification0001',
    provider: 'entrust',
    status: 'pending',
    riskLevel: 'low',
    fraudScore: 12,
    workflowReference: 'wf_abc123',
    providerWorkflowRunId: 'run_xyz789',
    dashboardLinkUrl: 'https://dashboard.example/kyc/abc',
    createdAt: '2026-05-25T17:46:54.000Z',
    updatedAt: '2026-05-25T18:00:00.000Z',
    completedAt: null,
    expiresAt: '2027-01-01T00:00:00.000Z'
  }
}
